import { React } from 'react';
import { Nav } from 'react-bootstrap';

const Navbar = () => {
  let scroll = document.querySelector('#nav');
  let mobileNavMenu = document.getElementById('mobile-nav-menu');
  let barsToogle = document.getElementById('navbar-toggle');

  window.addEventListener('scroll', () => {
    scroll.classList.toggle('scroll', window.scrollY > 300);
    mobileNavMenu.classList.toggle('scroll', window.scrollY > 300);
  })

  function toggleMenu() {
    mobileNavMenu.classList.toggle('mobile-nav-menu-active');
    barsToogle.classList.toggle('active');
  }

  function clouseMenu() {
    mobileNavMenu.classList.remove('mobile-nav-menu-active');
    barsToogle.classList.remove('active');
  }

  return (
    <>
      <nav className='navbar row navbar-expand-lg' id='nav'>
        <div className='col-4 logo'>
          <h3><span>Web</span><span>Shoh</span><span>Dev</span></h3>
        </div>
        <div className='col-8 menu'>
          <Nav.Link href='' className='bars text-right' id='navbar-toggle' onClick={toggleMenu}>
            <span></span>
          </Nav.Link>
          <ul className='list-group'>
            <li className='list-group-item items'><a href={'#header'}>Home</a></li>
            <li className='list-group-item items'><a href={'#about'}>About me</a></li>
            <li className='list-group-item items'><a href={"#services"}>Services</a></li>
            <li className='list-group-item items'><a href={"#experience"}>Experience</a></li>
            <li className='list-group-item items'><a href={"#portfolio"}>Portfolio</a></li>
            <li className='list-group-item items'><a href={'#contact'}>contacts</a></li>
          </ul>
        </div>
      </nav>
      <div className="mobile-nav-menu" id='mobile-nav-menu'>
        <ul className='list-group'>
          <li className='list-group-item items'><a href={'#header'} onClick={clouseMenu}>Home</a></li>
          <li className='list-group-item items'><a href={'#about'} onClick={clouseMenu}>About me</a></li>
          <li className='list-group-item items'><a href={"#services"} onClick={clouseMenu}>Services</a></li>
          <li className='list-group-item items'><a href={"#experience"} onClick={clouseMenu}>Experience</a></li>
          <li className='list-group-item items'><a href={"#portfolio"} onClick={clouseMenu}>Portfolio</a></li>
          <li className='list-group-item items'><a href={'#contact'} onClick={clouseMenu}>contacts</a></li>
        </ul>
      </div>
    </>
  )
}

export default Navbar